import React, { useEffect, useState } from "react"
import { Modal, Tabs } from "antd"
import LoginForm from "./components/LoginForm"
import RegisterForm from "./components/RegisterForm"
import ForgotPasswordForm from "./components/ForgotPasswordForm"

const ModalAuth = ({ visible, onClose, record, selectedPackage }) => {
  const [activeTab, setActiveTab] = useState("login")

  useEffect(() => {
    if (visible === "register") {
      setActiveTab("register")
    } else if (visible === "login") {
      setActiveTab("login")
    }
  }, [visible])

  const handleTabChange = key => {
    setActiveTab(key)
  }

  const renderTabPanes = () => {
    const panes = [
      {
        key: "login",
        label: "Đăng nhập",
        children: (
          <LoginForm
            onClose={onClose}
            record={record}
            setActiveTab={setActiveTab}
            selectedPackage={selectedPackage}
          />
        ),
      },
      {
        key: "register",
        label: "Đăng ký",
        children: (
          <RegisterForm onClose={onClose} setActiveTab={setActiveTab} />
        ),
      },
    ]

    if (activeTab === "forgot") {
      panes.push({
        key: "forgot",
        label: "Quên mật khẩu",
        children: <ForgotPasswordForm setActiveTab={setActiveTab} />,
      })
    }

    return panes
  }

  return (
    <Modal
      open={!!visible}
      onCancel={onClose}
      footer={null}
      title="Chào mừng bạn!"
      centered
      destroyOnClose
    >
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        centered
        items={renderTabPanes()}
      />
    </Modal>
  )
}

export default ModalAuth
